export function createSettingsOrchestrator(context = {}) {
  const {
    getSiteThemeModuleApi,
    ensureSiteThemeModuleReady,
    getSiteThemeFullscreenModuleApi,
    ensureSiteThemeFullscreenModuleReady
  } = context;

  function requestAppFullscreen() {
    if (getSiteThemeFullscreenModuleApi()?.requestAppFullscreen) {
      getSiteThemeFullscreenModuleApi().requestAppFullscreen();
      return;
    }
    ensureSiteThemeFullscreenModuleReady()
      .then((mod) => {
        mod?.requestAppFullscreen?.();
      })
      .catch(() => {});
  }

  function setupSiteThemeLongPressFullscreen() {
    if (getSiteThemeFullscreenModuleApi()?.setupSiteThemeLongPressFullscreen) {
      getSiteThemeFullscreenModuleApi().setupSiteThemeLongPressFullscreen();
      return;
    }
    ensureSiteThemeFullscreenModuleReady()
      .then((mod) => {
        mod?.setupSiteThemeLongPressFullscreen?.();
      })
      .catch(() => {});
  }

  function loadSiteTheme() {
    if (getSiteThemeModuleApi()?.loadSiteTheme) {
      getSiteThemeModuleApi().loadSiteTheme();
      return;
    }
    ensureSiteThemeModuleReady()
      .then((mod) => {
        mod?.loadSiteTheme?.();
      })
      .catch(() => {});
  }

  function toggleSiteTheme() {
    if (getSiteThemeModuleApi()?.toggleSiteTheme) {
      getSiteThemeModuleApi().toggleSiteTheme();
      return;
    }
    ensureSiteThemeModuleReady()
      .then((mod) => {
        mod?.toggleSiteTheme?.();
      })
      .catch(() => {});
  }

  function applySiteTheme(theme) {
    if (getSiteThemeModuleApi()?.applySiteTheme) {
      getSiteThemeModuleApi().applySiteTheme(theme);
      return;
    }
    ensureSiteThemeModuleReady()
      .then((mod) => {
        mod?.applySiteTheme?.(theme);
      })
      .catch(() => {});
  }

  function getCurrentSiteTheme() {
    if (getSiteThemeModuleApi()?.getCurrentSiteTheme) {
      return getSiteThemeModuleApi().getCurrentSiteTheme();
    }
    return localStorage.getItem('siteTheme') || 'dark';
  }

  function syncModalOverlayTheme() {
    if (getSiteThemeModuleApi()?.syncModalOverlayTheme) {
      getSiteThemeModuleApi().syncModalOverlayTheme();
      return;
    }
    ensureSiteThemeModuleReady()
      .then((mod) => {
        mod?.syncModalOverlayTheme?.();
      })
      .catch(() => {});
  }

  function syncThemeColor() {
    if (getSiteThemeModuleApi()?.syncThemeColor) {
      getSiteThemeModuleApi().syncThemeColor();
      return;
    }
    ensureSiteThemeModuleReady()
      .then((mod) => {
        mod?.syncThemeColor?.();
      })
      .catch(() => {});
  }

  return {
    requestAppFullscreen,
    setupSiteThemeLongPressFullscreen,
    loadSiteTheme,
    toggleSiteTheme,
    applySiteTheme,
    getCurrentSiteTheme,
    syncModalOverlayTheme,
    syncThemeColor
  };
}
